import script from "./GodApeQuestFinishModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GodApeQuestFinishModal.vue?vue&type=script&setup=true&lang=js"

import "./GodApeQuestFinishModal.vue?vue&type=style&index=0&id=98e3c504&lang=scss"

const __exports__ = script;

export default __exports__